var map = {
	"./data/abis/TokenERC20STO-ABI.json": 9000,
	"./data/dummy.json": 9848,
	"./data/metadata.json": 6680,
	"./locales/en.json": 790,
	"./locales/es.json": 8563,
	"./modules/about-us/data/team.json": 5525,
	"./modules/landing/data/benefit.json": 645,
	"./services/wallet/abis/abi.json": 5958,
	"./services/wallet/abis/kastor-abi.json": 3252
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2812;